import { EmailTemplate } from '../types/emailBuilder';

const EMPTY_EMAIL_FALLBACK = `<!DOCTYPE html>
<html>
  <head>
    <meta charSet="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Empty Email</title>
  </head>
  <body style="margin:0;padding:32px;background:#f8fafc;font-family:Arial,sans-serif;color:#111827;">
    <table role="presentation" width="100%" cellPadding="0" cellSpacing="0">
      <tr>
        <td align="center">
          <table role="presentation" width="480" cellPadding="0" cellSpacing="0" style="background:#ffffff;border-radius:12px;padding:32px;border:1px solid #e5e7eb;">
            <tr>
              <td align="center" style="font-size:16px;line-height:1.5;">
                <strong>This template does not contain any content yet.</strong>
                <div style="margin-top:8px;color:#6b7280;">Start designing to see a preview.</div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;

/**
 * Returns HTML for a template, falling back to legacy component rendering when needed.
 * Always returns a safe HTML string so downstream consumers can rely on it.
 */
export const ensureTemplateHtml = async (template: EmailTemplate): Promise<string> => {
  const html = template.htmlContent?.trim();
  if (html) {
    return html;
  }

  return EMPTY_EMAIL_FALLBACK;
};



